import React from "react";
import NavBarItem from "./NavbarComponent/NavBarItem";
import Header from "./HeaderComponent/Header";
import ListCities from "./ListCityComponets/ListCities";
import ListHotelsType from "./ListHotelTypeComonents/ListHotelsType";
import ListHotels from "./ListHotels/ListHotels";
import Form from "./FormComponent/Form";
import FooterComponent from "./FooterComponent/FooterComponent";
const Home = () => {
  return (
    <div>
      <NavBarItem />
      <Header />
      <ListCities />
      <ListHotelsType />
      <ListHotels />
      <Form />
      <FooterComponent />
    </div>
  );
};

export default Home;
